module.exports = __webpack_public_path__ + "static/media/adobe-illustrator.21d4729a.svg";